import Axios from "axios";
import { BaseUrlConnection } from "../../utils/Connection";

export default Axios.create({
  baseURL: BaseUrlConnection(),
  withCredentials: true,
  timeout: 60000,
});
